import React, { useState } from 'react';
import { Phone, Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { mockData } from '../mock';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navLinks = [
    { name: 'Services', href: '#services' },
    { name: 'Coverage Areas', href: '#coverage' },
    { name: 'About', href: '#about' },
    { name: 'Testimonials', href: '#testimonials' },
    { name: 'FAQ', href: '#faq' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <div className="flex-shrink-0">
            <img 
              src="https://customer-assets.emergentagent.com/job_cck-transport-hub/artifacts/ybiocqgn_2022-removebg-preview.png" 
              alt="CCK Possibilities LLC - Non Emergency Medical Transport"
              className="h-28 w-auto"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-gray-700 hover:text-blue-600 font-medium transition-colors"
              >
                {link.name}
              </a>
            ))}
          </nav>

          {/* Phone CTA */}
          <div className="hidden md:flex items-center space-x-4">
            <a
              href={`tel:${mockData.company.phone.replace(/\D/g, '')}`}
              className="flex items-center space-x-2 text-cyan-500 hover:text-cyan-600 font-semibold transition-colors"
            >
              <Phone className="w-5 h-5" />
              <span>{mockData.company.phone}</span>
            </a>
            <Button 
              className="bg-gradient-to-r from-cyan-500 to-purple-600 hover:from-cyan-600 hover:to-purple-700 text-white"
              onClick={() => {
                document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' });
                setTimeout(() => {
                  document.querySelector('#name')?.focus();
                }, 1000);
              }}
            >
              Book a Ride
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? (
              <X className="w-6 h-6 text-gray-300" />
            ) : (
              <Menu className="w-6 h-6 text-gray-300" />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <nav className="px-4 py-4 space-y-3">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="block py-2 text-gray-700 hover:text-cyan-500 font-medium transition-colors"
                onClick={() => setMobileMenuOpen(false)}
              >
                {link.name}
              </a>
            ))}
            <div className="pt-4 space-y-3">
              <a
                href={`tel:${mockData.company.phone.replace(/\D/g, '')}`}
                className="flex items-center space-x-2 text-cyan-500 font-semibold py-2"
              >
                <Phone className="w-5 h-5" />
                <span>{mockData.company.phone}</span>
              </a>
              <Button 
                className="w-full bg-gradient-to-r from-cyan-500 to-purple-600 hover:from-cyan-600 hover:to-purple-700 text-white"
                onClick={() => {
                  setMobileMenuOpen(false);
                  document.querySelector('#contact').scrollIntoView({ behavior: 'smooth' });
                  setTimeout(() => {
                    document.querySelector('#name')?.focus();
                  }, 1000);
                }}
              >
                Book a Ride
              </Button>
            </div>
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
